import { configureStore } from "@reduxjs/toolkit";
import programReducer from "./slices/program";
import speakerReducer from "./slices/speakers";
import eventReducer from "./slices/event";
import photoAlbumReducer from "./slices/photoAlbum";
import areaMapsReducer from "./slices/areaMaps";

export const store = configureStore({
	reducer: {
		program: programReducer,
		speakers: speakerReducer,
		event: eventReducer,
		photoAlbum: photoAlbumReducer,
		areaMaps: areaMapsReducer,
	},
});
